var map = {
	"./WhatsApp Image 2025-06-21 at 12.32.42 PM (1).jpeg": 59939,
	"./WhatsApp Image 2025-06-21 at 12.32.42 PM.jpeg": 77597,
	"./WhatsApp Image 2025-06-21 at 12.32.43 PM.jpeg": 49232,
	"./WhatsApp Image 2025-06-21 at 12.32.44 PM.jpeg": 63395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90907;